import Button from 'components/Form/Button';
import { CoreContext } from 'context/CoreContext';
import moment from 'moment';
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { toast } from 'react-toastify';
import { Title, Touch } from 'ui/styled';
import { capitalize } from 'utils';
import { Buscar, Create } from '../../../services/historico';
import FormCore from '../../Form/Core';
import Wrapper from '../Wrapper';
import {
  AddProposalContainer,
  CompanyButtonContainer,
  TimelineContainer,
  TimelineContent,
  TimelineItem,
} from './styled';

export default function ModalObservacao({ dados, reload, origem }) {
  const { setModal, user } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const [register, setRegister] = useState(dados);
  const [historico, setHistorico] = useState(false);
  const [obs, setObs] = useState();

  const close = () => setModal(null);
  const valorBiblioteca = register?.biblioteca === true ? true : false;

  //muda o titulo na biblioteca para nao aparecer a palavra Adicionar.
  let titulo;
  if (valorBiblioteca) {
    titulo = 'Ver';
  } else {
    titulo = 'Adicionar';
  }

  //nome do cliente no controle e financiamento
  const clienteFinanceiro = register.customer;
  const clienteMesa = !register.cliente ? register.customer : register.cliente;
  //id proposta no controle e financiamento
  const propostamesa = !register.proposta ? register.id : register.proposta;
  const propostafinanceira = register.id;
  //status no controle e financiamento
  const statusMesa = register?.original?.status;
  //variaveis para pegar os valores conforme a estapa que esta.
  let cliente;
  let idproposta;
  if (statusMesa) {
    idproposta = propostamesa;
    cliente = clienteMesa;
  } else {
    idproposta = propostafinanceira;
    cliente = clienteFinanceiro;
  }

  // busca na tabela historico todos que forem daquele id da proposta
  const init = useCallback(async () => {
    setLoading(true);
    try {
      const data = await Buscar(idproposta);

      if (!data.length) {
        setLoading(false);
        return;
      }
      const sorted = data.sort((a, b) => (b.id || 0) - (a.id || 0));

      setObs(sorted);
    } catch (err) {
      console.error('Erro ao carregar propostas:', err);
      toast.error('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => init(), [init]);

  const historicoInvertidos = useMemo(() => {
    let valor;
    if (!obs) {
      valor = [];
    } else {
      valor = obs;
    }
    return valor;
  }, [obs]);

  const formTexto = [
    {
      ref: 'observacao',
      placeholder: 'Observação',
      type: 'text',
      required: true,
      full: true,
      multiline: true,
      maxRows: 4,
      height: 100,
    },
  ];

  const salve = async () => {
    try {
      setLoading(true);
      const form = await formRef.current.getForm?.();
      if (!form) {
        return;
      }
      const payload = {
        users_permissions_user: user.id,
        data: new Date(),
        observacao: form.observacao,
        origem: origem,
        proposta_financeira: idproposta,
      };

      const result = await Create({ data: payload });
      // if (result.status !== 200) {
      //   throw new Error('Erro ao salvar');
      // }

      toast.success('Registro salvo com sucesso!');
      close();
      reload?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper title={`${titulo} Observação`} close={close} loading={loading}>
      Proposta: {idproposta} - Cliente: {cliente}
      <AddProposalContainer>
        {valorBiblioteca === false && (
          <FormCore ref={formRef} formItems={formTexto} />
        )}
      </AddProposalContainer>
      <div style={{ display: 'grid', width: '100%', gap: '20px' }}>
        <Touch
          onClick={() => setHistorico(!historico)}
          style={{
            cursor: 'point',
            display: 'flex',
            alingItems: 'center',
            justifyContent: 'space-between',
            background: '#f4f4f4',
            padding: '10px',
            borderRadius: '4px',
          }}
        >
          <Title nomargin small>
            Historico: ({historicoInvertidos.length})
          </Title>
          <span
            style={{
              transition: '0.3',
              transform: historico ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          >
            ▼
          </span>
        </Touch>
        {historicoInvertidos.length > 0 && historico && (
          <TimelineContainer>
            {historicoInvertidos.map((obs, idx) => (
              <TimelineItem key={idx}>
                <TimelineContent>
                  <div style={{ marginBottom: '4px' }}>
                    <strong style={{ color: '#2d3748', fontSize: '14px' }}>
                      {capitalize(obs.users_permissions_user.username)}
                    </strong>
                    <span
                      style={{
                        color: '#718096',
                        fontSize: '12px',
                        marginLeft: '8px',
                      }}
                    >
                      {moment(obs.data).format('DD/MM/YYYY HH:mm')} - (
                      {obs.origem})
                    </span>
                  </div>
                  <span
                    style={{
                      fontSize: '15px',
                      color: '#4a5568',
                      lineHeight: '1.4',
                    }}
                  >
                    {obs.observacao}
                  </span>
                </TimelineContent>
              </TimelineItem>
            ))}
          </TimelineContainer>
        )}
        <CompanyButtonContainer>
          <Button color="lightgrey" onClick={close} nospace>
            Cancelar
          </Button>
          <Button color="botao" onClick={salve} nospace>
            Salvar
          </Button>
        </CompanyButtonContainer>
      </div>
    </Wrapper>
  );
}
